const getFedoraKeys = () => $('#fedora-keys').data()

const getFedoraData = () => $('#fedora-data').data()
;(window as any).getFedoraKeys = getFedoraKeys
;(window as any).getFedoraData = getFedoraData
